import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Transporter } from '../../../models/transporter.model';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'jhi-bary-disconnected-nav-bar',
  templateUrl: './bary-disconnected-nav-bar.component.html',
  styleUrls: ['./bary-disconnected-nav-bar.component.scss'],
})
export class BaryDisconnectedNavBarComponent {
  @Input() transporter!: Transporter;
  @Input() sideClass = 'navbar navbar-dark navbar-expand-lg fixed-top justify-content-between primary-color';
  @Output() goToEvent = new EventEmitter<string>();
  @Output() registerEvent = new EventEmitter<void>();
  @Output() loginEvent = new EventEmitter<void>();

  logo = environment.urlApi + '/api/img/logo-disconnected';

  public handleGoTo(path: string): void {
    this.goToEvent.emit(path);
  }

  public handleLogin(): void {
    this.loginEvent.emit();
  }
}
